import { Markdown } from '@/ui/Markdown';
import { Badge, Kicker } from '@/ui/primitives';
import type { WireTaskEvidence, WireResultDetail } from '@/api/wire';
import { sourceLabel } from './copy';

export function TaskResult({ evidence }: { evidence: WireTaskEvidence }) {
  const detail = evidence.detail as WireResultDetail | null;
  if (!detail) {
    return <p className="m-0 text-dense text-meta">The answer was erased with the key it was sealed under.</p>;
  }
  return (
    <section className="flex flex-col gap-3 rounded-brand border border-line p-5" aria-label="The answer" data-testid="twin-task-result">
      <Kicker tone="accent">The answer</Kicker>
      {(detail.completionStatus === 'length' || detail.completionStatus === 'blocked') && <p role="status">Partial result: {detail.completionReason ?? detail.completionStatus}. The task was returned for your decision.</p>}
      <Markdown text={detail.answer} />
      {(detail.sources ?? []).length > 0 && (
        <ol className="m-0 flex list-none flex-col gap-2 p-0" aria-label="Sources">
          {(detail.sources ?? []).map((s) => (
            <li key={s.url} className="flex flex-wrap items-baseline gap-2 text-dense" data-testid="twin-task-source" data-verified={s.verified ? 'yes' : 'no'}>
              <Badge tone={s.verified ? 'accent' : 'auto'} plain>
                {sourceLabel(s.verified)}
              </Badge>
              <a href={s.url.startsWith('https://') || s.url.startsWith('http://') ? s.url : undefined} target="_blank" rel="noreferrer noopener" className="underline break-words">{s.title || s.url}</a>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}

